import "./MapPin.scss";

export default function MapPin(props: {
  lat: number;
  lng: number;
  address: string;
}) {
  return <div className="mapPin"></div>;
}
